// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__31SN0","facedown":"styles_facedown__1x3mV","solved":"styles_solved__EFxCm","faceup":"styles_faceup__25GpJ"};